























import { Component, Prop, Vue } from "vue-property-decorator";
import { Global } from "../../core/helpers/global";

@Component
export default class CzButton extends Vue {
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: String, default: "" }) href!: string;
  @Prop({ type: String, default: "button" }) type!: string;
  @Prop({ type: String, default: "primary" }) variant!: "primary" | "ghost";
  @Prop({ type: Boolean, default: false }) small!: boolean;
  @Prop({ type: Boolean, default: false }) inline!: boolean;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  onClick(e: Event) {
    const id = this.$attrs.id;
    if (id) Global.TriggerDomId = id;
    this.$emit("click", e);
  }

  get classes() {
    return {
      "czButton--ghost": this.variant === "ghost",
      "czButton--small": this.small,
      "czButton--inline": this.inline || this.small,
    };
  }
}
